export const loginCheck = (username, password) => {
    return {
        type: 'LOGIN_CHECK',
        payload: {
            username: username,
            password: password
        }
    }
}
export const selectTopTab = (id) => {
    return {
        type: 'SELECT_TOP_TAB',
        payload: {
            id: id
        }
    }
}
export const leftBarClicked = () => {
    return {
        type: 'LEFT_BAR_CLICKED'
    }
}
export const searchBarClicked = () => {
    return {
        type: 'SEARCH_BAR_CLICKED'
    }
}
export const filterBarClicked = () => {
    return {
        type: 'FILTER_BAR_CLICKED'
    }
}
export const rightBarClicked = () => {
    return {
        type: 'RIGHT_BAR_CLICKED'
    }
}
export const chatBarClicked = () => {
    return {
        type: 'CHAT_BAR_CLICKED'
    }
}
export const todoBarClicked = () => {
    return {
        type: 'TODO_BAR_CLICKED'
    }
}
export const footerListBtnClicked = () => {
    return {
        type: 'FOOTER_LIST_BTN_CLICKED'
    }
}
export const footerGreenAreaClicked = () => {
    return {
        type: 'FOOTER_GREEN_AREA_CLICKED'
    }
}
export const loggingOut =() =>{
    return {
        type: 'LOGGING_OUT'
    }
}
export const toolKitClicked =() => {
    return {
        type: 'TOOLKIT_CLICKED'
    }
}
export const toolKitReleased =() => {
    return {
        type: 'TOOLKIT_RELEASED'
    }
}
export const toolKitMove =(x, y) => {
    return {
        type: 'TOOLKIT_MOVE',
        payload: {
            x:x,
            y:y
        }
    }
}
export const setModalData =(obj) => {
    return {
        type: 'SET_MODAL_DATA',
        payload: {
            obj:obj
        }
    }
}
export const setModalFlag =(flag) => {
    return {
        type: 'SET_MODAL_FLAG',
        payload: {
            flag:flag
        }
    }
}
export const setSavedProgrammiTab =(obj, index) => {    
    return {
        type: 'SET_SAVED_PROGRAMMI_TAB',
        payload: {
            obj:obj,
            index: index
        }
    }
}

